import { Configuration } from "@azure/msal-browser";

export const msalConfig: Configuration = {
	auth: {
		clientId: process.env.REACT_APP_MSAL_CLIENT_ID!,
		authority: process.env.REACT_APP_MSAL_AUTHORITY!,
		redirectUri: window.location.origin,
		postLogoutRedirectUri: window.location.origin + "/login",
	},
	cache: {
		cacheLocation: "localStorage",
	},
};

export const loginRequest = {
	scopes: ["openid", "profile", "email"],
};
